import {Component} from '@lib/Component';
import {MediaQuery} from '@services/MediaQuery';
import {WindowService} from '@services/WindowService';

export class Sticky extends Component {
  observer: IntersectionObserver | null = null;
  mediaQuery = MediaQuery.create();
  target: HTMLElement | null | undefined = null;
  targetSp: HTMLElement | null | undefined = null;
  window = WindowService.create();

  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onIntersection = this.onIntersection.bind(this);
    this.onResize = this.onResize.bind(this);
    this.window.onResize.connect(this.onResize);
  }

  onResize() {
    const back = this.element?.querySelector('.backdrop') as HTMLElement;
    if (back) {
      const {height = 0} = this.target?.getBoundingClientRect() || {};
      back.style.height = `${height}px`;
    }
  }

  createBackdrop(target: HTMLElement) {
    const old = this.element?.querySelector('.backdrop');
    old && this.element?.removeChild(old);
    const {height = 0} = target.getBoundingClientRect() || {};
    const back = document.createElement('div');
    back.className = 'backdrop';
    back.style.height = `${height}px`;
    back && this.element?.prepend(back);
  }

  didMount() {
    const targetQuery = this.element?.dataset.target;
    targetQuery && (this.target = this.element?.querySelector(targetQuery));
    if (this.element && this.target) {
      this.createBackdrop(this.target);
      this.observer = new IntersectionObserver(this.onIntersection, {
        rootMargin: '0px',
        threshold: [0.0, 1.0],
      });
      this.observer.observe(this.element);
    }
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      window.removeEventListener('scroll', this.onScroll);
      if (entry.isIntersecting) {
        window.addEventListener('scroll', this.onScroll);
      }
    }
  }

  onScroll() {
    const target = this.target;
    if (this.element && target) {
      const {top, height} = this.element.getBoundingClientRect();
      if (top < 0) {
        target.style.position = 'fixed';
        target.style.top = '0';
        target.style.bottom = 'auto';

        const {height: targetHeight} = target.getBoundingClientRect();
        const isBottom = top < -(height - targetHeight);
        if (isBottom) {
          target.style.position = 'absolute';
          target.style.top = 'auto';
          target.style.bottom = '0';
        }
      } else {
        target.style.position = 'absolute';
        target.style.top = '0';
        target.style.bottom = 'auto';
      }
    }
  }

  didUnmount() {
    this.element && this.observer?.unobserve(this.element);
    this.observer = null;
    this.window.onResize.disconnect(this.onResize);
  }
}
